import { Injectable } from '@angular/core'
import {Observable} from 'rxjs';
import {ResponseRequestModel} from '../../models/response.model';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly TOKEN_KEY = 'authToken'
  private readonly TIMESTAMP_KEY = 'tokenTimestamp'
  private readonly EXPIRATION_TIME = 12 * 60 * 60 * 1000
  private readonly PERMISSIONS = 'permissions'
  private baseUrl = environment.baseUrl
  constructor(
    private httpClient: HttpClient
) {}

  saveToken(token: string): void {
    const currentTime = new Date().getTime()
    localStorage.setItem(this.TOKEN_KEY, token)
    localStorage.setItem(this.TIMESTAMP_KEY, currentTime.toString())
  }
  public getProfile(){
    return localStorage.getItem('perfil')
  }
  public getMunicipio(){
    return localStorage.getItem('municipio')
  }
  public  getUnidade(){
    return localStorage.getItem('unidade')
  }
  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY)
  }

  isTokenValid(): boolean {
    const tokenTimestamp = localStorage.getItem(this.TIMESTAMP_KEY)
    if (tokenTimestamp) {
      const currentTime = new Date().getTime()
      const tokenAge = currentTime - parseInt(tokenTimestamp, 10)
      return tokenAge < this.EXPIRATION_TIME
    }
    return false
  }

  clearToken(): void {
    localStorage.removeItem(this.TOKEN_KEY)
    localStorage.removeItem(this.TIMESTAMP_KEY)
  }
  public resetPassword(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}usuario/reset-password`,
      model,
    )
  }
  savePermissions(permissions: any[]): void {
    localStorage.setItem(this.PERMISSIONS, JSON.stringify(permissions))
  }

  getPermissions(): string | null {
    return localStorage.getItem(this.PERMISSIONS)
  }

  getPermissionsObject(): any | null {
    const permissions = localStorage.getItem(this.PERMISSIONS)
    if (permissions) {
      return JSON.parse(permissions)
    } else {
      return null
    }
  }

    checkPermission(permission: string, screen: string): boolean {
      return this.getPermissionsObject().some((item: any) =>
        item.modulo.toLowerCase().replaceAll(' ', '-').trim() === screen.toLowerCase() &&
        item.acoes.some(
          (acao: any) =>
            acao.descricao.toLowerCase() === permission.toLowerCase()
        )
      )
    }

  clearPermissions(): void {
    localStorage.removeItem(this.PERMISSIONS)
  }

  login(token: string): void {
    this.saveToken(token)
  }

  logout(): void {
    this.clearToken()
    this.clearPermissions()
  }
}
